import React from 'react'

const WishesFeatures = () =>
  <div className="page feature">
    <h1>Wishes</h1>
  </div>

export default WishesFeatures
